import type { ComboboxPropRenderValue } from '@consta/uikit/Combobox'
import { Text } from '@consta/uikit/Text'

import type { Item } from '../types'
import css from './DraftComboboxValue.css'

type RenderItemProps<T extends object> = Parameters<ComboboxPropRenderValue<T>>['0']

/**
 * Компонент для рендера драфтого элемента в выбранном состоянии в Select/Combobox
 *
 * Объекты, помещаемые в Select/Combobox должны расширять следующий тип:
 *
 * ```ts
 * type Item = {
 *   state: 'Draft' | 'Public'
 *   name?: string
 * }
 * ```
 */
export function DraftComboboxValue<T extends Item>({ item: { name, state } }: RenderItemProps<T>) {
  const isDraft = state === 'Draft'

  return (
    <Text
      className={css.draftComboboxValue}
      as="span"
      truncate={true}
      size="xs"
      fontStyle={isDraft ? 'italic' : undefined}
      view={isDraft ? 'ghost' : 'primary'}>
      {name}
    </Text>
  )
}
